import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from "framer-motion";

const Buy = props => {
    const [status, setStatus] = useState({step:0, data:null});
    const [waiting, setWaiting] = useState(0);
    const timerRef = useRef(null);

    const waitingTime = () => {
        setWaiting(waiting => waiting + 1);
    }
    const shortenAddress = address => {
        return (address.substr(0,6) + "..." + address.substr(address.length-6, 6))
    }
    const generateToken = async(r) => {
       //let r = await props.blockchain.infura.web3.eth.getTransactionReceipt("0x6d926eceedd366e1b510e69a5c675376c5ba6fe6d44decf0157e0b399524399d");
        let newTokenId = props.blockchain.infura.web3.utils.hexToNumber(r.events[0].raw.topics[3]); // r.logs[0].topics[3] r.events[0].raw.topics[3] 
        // Be sure that the token doesn't already exists in the array
        if (props.tokenList.every((e)=> e.vid !== newTokenId)) {
            let newToken = [];
            newToken.id = newTokenId - props.blockchain.artblock.tokenPrefix;
            newToken.hash = await props.blockchain.infura.contract.methods.tokenIdToHash(newTokenId).call();
            newToken.owner = await props.blockchain.infura.contract.methods.ownerOf(newTokenId).call();
            newToken.ownerShort = shortenAddress(newToken.owner);
            newToken.ownerUrl = "https://etherscan.io/address/" + newToken.owner;
            newToken.vid = newTokenId;
            newToken.salePrice = null;
            let newTokenList = [newToken, ...props.tokenList];
            props.setTokens(newTokenList); // Is this going to work?
            setStatus({step:2, data:r.events[0].transactionHash});
            // Call to ArtBlocks API to generate thumbanil
            // https://rinkebyapi.artblocks.io/image/
            fetch("https://artblocks.io/image/" + newTokenId + "/Refresh")
            .then(() => console.log("Artblocks API for token " + newTokenId + " activated with success.")); 
        } else {
            props.setModal({enabled:true, message:"Token already exists. Something went wrong!"});
        }
    }

    const showPurchasedToken = () => {
        props.setCanvas({enabled:true, display:"purchase", token:props.tokenList[0]}); // should be props.tokenList[0]*/
    }

    const purchaseToken = async() => {
        console.log(props.blockchain.artblock.minterAbi, props.blockchain.artblock.minter);
        const contract = new props.blockchain.metamask.web3.eth.Contract(props.blockchain.artblock.minterAbi, props.blockchain.artblock.minter);
        const purchase = await contract.methods.purchase(props.blockchain.artblock.projectId).send({
            from: props.blockchain.metamask.accounts[0],
            gas: 435534,
            value: props.blockchain.artblock.projectTokenInfo.pricePerTokenInWei
        })
        .on('transactionHash', function(hash){
            setStatus({step:1, data:hash});
            if (!timerRef.current) {
                timerRef.current = setInterval(waitingTime, 1000);
            }
        })
        .on('receipt', function(receipt){
            generateToken(receipt);
            console.log("receipt", receipt);
        })
        .on('error', error => {
            setStatus({step:-1, data:error.metamask});
            if (error.code === 4001) {
                props.setModal({enabled:true, message:"You need to accept the transaction in order to purchase a new token. Please try again!"});
            } else {
                props.setModal({enabled:true, message:"Transaction failed: " + error.message});
            }
        }); 
    } 

    const buyVariant = {
        hidden: {
            y:20,
            opacity: 0
        },
        visible: {
            y:0,
            opacity:1,
            transition: {
                delay: 0.1, 
                duration: 0.5
            }
        },
        done: {
            y:-20,
            opacity: 0
        },
    }

    useEffect(()=>{
        props.setCanvas({enabled:false, display:"background", token:props.tokenList[0]});
        purchaseToken();
        //generateToken();
        return () => { if (timerRef.current) { clearInterval(timerRef.current); console.log("Timer cleared")} }
    },[]);

    const steps = s => {
            

        switch(s.step) {
            case -1:
              return (
                <>
                <motion.div key="step-error" className="container sp-buy has-text-black has-text-centered" initial="hidden" animate="visible" exit="done" variants={buyVariant}> 
                    <p className="is-size-1 is-size-3-mobile">Transaction <br/>failed!</p>
                    <button className="button is-size-7 is-primary is-rounded is-outlined mt-4" onClick={purchaseToken}>Try again</button>
                </motion.div>
                </>
              )
            case 0: 
              return (
                <motion.div key="step-0" className="container sp-buy has-text-black has-text-centered" initial="hidden" animate="visible" exit="done" variants={buyVariant}> 
                    <p className="is-size-1 is-size-3-mobile">Awaiting <br/>confirmation</p>
                    <p className="sp-loader mt-4"></p>
                </motion.div>
              )
            case 1:
              return (
                <motion.div key="step-1" className="container sp-buy has-text-black has-text-centered" initial="hidden" animate="visible" exit="done" variants={buyVariant}> 
                    <p className="is-size-1 is-size-3-mobile">Transaction <br/>initialized</p>
                    <p className="sp-loader mt-4"></p>
                    <p className="is-size-7 mt-4">Transaction hash: {s.data} <a className="has-text-black" href={"https://etherscan.io/tx/"+s.data}>&rarr;</a><br/>
                    { (waiting <= 20) ? 
                        ("Waiting for confirmations " + waiting + " seconds.") 
                    :   ("Anxious after " + waiting + " seconds? Consider increasing gas.")
                    }
                    </p>
                </motion.div>
              )
              case 2:
                return (
                  <motion.div key="step-2" onClick={showPurchasedToken} className="container is-clickable sp-buy has-text-black has-text-centered" initial="hidden" animate="visible" exit="done" variants={buyVariant}> 
                      <p className="is-size-1 is-size-3-mobile"><i className="fa fa-check-circle"></i></p>
                      <p className="is-size-1 is-size-3-mobile">You purchased<br/>Spectron {props.tokenList[0].id}!</p>
                      <p className="is-size-7 mt-4">Take a look at your new video artwork here!</p>
                  </motion.div>
                )
          }
    }

  
    return (
      <AnimatePresence exitBeforeEnter>
        {steps(status)}
      </AnimatePresence>
    )
  };
  
  export default Buy;